import { Timestamp } from '../types/datetime';

const MS_PER_MINUTE = 60000;

export const getCurrentTimestamp = (): Timestamp => {
  return Date.now();
};

export const addMinutes = (timestamp: Timestamp, minutes: number): Timestamp => {
  return timestamp + minutes * MS_PER_MINUTE;
};

export const isExpired = (expiredAt: Timestamp): boolean => {
  return Date.now() > expiredAt;
};
